import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'modules/store';

const selectState = (x: RootState) => x.customMailReducer;

export const selectMailTypes = createSelector(selectState, (data) => data.types);

export const selectMailEntities = (state: RootState) => state.customMailReducer.entities;

export const selectMailTempalate = createSelector(selectState, (data) => data.template);

export const selectEntityMembersList = createSelector(selectState, (data) => data.entityMembersList);

export const selectMailUsersList = createSelector(selectState, (data) => data.usersList);

export const selectCountryList = createSelector(selectState, (data) => data.countryList);

export const selectSentList = createSelector(selectState, (data) => data.sentList);
